export const Operations = Object.freeze({
  COMPRA: 'Compra',
  DESCONTO_CONCEDIDO: 'Desconto Concedido',
  DEVOLUCAO_PRODUTO: 'Devolução de Produto em Depósito',
  ENTRADA_DEPOSITO: 'Entrada para Depósito',
  QUEBRA_ARMAZENAGEM: 'Quebra Técnica e Armazenagem',
  TAXA_SERVICO: 'Taxa de Serviços e Trocas',
  TRANSFERENCIA: 'Transferência',
  VENDA: 'Venda'
});